module.exports = __webpack_public_path__ + "static/media/HighGuardianOfAether01.b142e9ad.jpg";